import { Reveal, SectionTitle } from "@/components/site/Primitives";

export const OfficeSection = ({ o, className = "container-x pt-20 sm:pt-28", testid = "office-section" }) => (
  <section data-testid={testid} className={className}>
    <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-6">
        <Reveal><SectionTitle title={o.title} /></Reveal>
        <p data-testid={`${testid}-text`} className="mt-6 max-w-xl text-[15px] leading-relaxed text-forest/75">{o.text}</p>
        <p data-testid={`${testid}-address`} className="mt-8 text-lg font-semibold leading-snug text-forest">{o.address}</p>
        <p data-testid={`${testid}-note`} className="mt-2 text-[15px] leading-relaxed text-forest/75">{o.note}</p>
      </div>
      <img
        src="/img/sejna-soba-izola.webp"
        alt={o.alt}
        width="1179"
        height="1176"
        loading="lazy"
        data-testid={`${testid}-photo`}
        className="h-auto w-full max-w-xl rounded-[32px] lg:col-span-6 lg:max-w-none"
      />
    </div>
  </section>
);
